import ISettings from "../interfaces/ISettings";

const storage = localStorage;

export const updateSettings = (settings: ISettings) => {
    storage.setItem("settings", JSON.stringify(settings));
};

export const getSettings = (): ISettings => {
    const data = storage.getItem("settings");
    if (!data) {
        return {
            weeksToLoad: 5,
            syncWithOutlook: true,
            reportFilter: "ALL",
            isDefault: true,
            copyLinks: false
        };
    }
    return JSON.parse(data);
};

export const setShowOnlyMyProjects = (showOnlyMyProjects: boolean) => {
    storage.setItem("showOnlyMyProjects", JSON.stringify(showOnlyMyProjects));
};

export const getShowOnlyMyProjects = (): boolean => {
    const data = storage.getItem("showOnlyMyProjects");
    if (!data) {
        return false;
    }
    return JSON.parse(data);
};

export const setSelectedProjectView = (view: string) => {
    storage.setItem("selectedProjectView", JSON.stringify(view));
};

export const getSelectedProjectView = (): string => {
    const data = storage.getItem("selectedProjectView");
    if (!data) {
        return "Aktivní";
    }
    return JSON.parse(data);
};

export const setCopyLinks = (copyLinks: boolean) => {
    storage.setItem("copyLinks", JSON.stringify(copyLinks));
};

export const getCopyLinks = (): boolean => {
    const data = storage.getItem("copyLinks");
    if (!data) {
        return false;
    }
    return JSON.parse(data);
};

export const setSelectedTaskView = (view: string) => {
    storage.setItem("selectedTaskView", JSON.stringify(view));
};

export const getSelectedTaskView = (): string => {
    const data = storage.getItem("selectedTaskView");
    if (!data) {
        return "Moje";
    }
    return JSON.parse(data);
};
